import { getId } from '@/utils/temporaryHelper'

export const InitialSectionIds = {
  main: getId(),
  secondary: getId(),
}
